/*  MUI  */
import { Typography } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const PublisherCell = (props) => {
    const { t } = useTranslation();
    const { row } = props;
    const { publisherName } = row.original.application;
    return <Typography>{publisherName || t('Common.noPublisher')}</Typography>;
};
